/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc service
 * @name DNSQueryCollection
 * @description
 *
 *     Collection of Metrics with a unique DataTransformer for parsing data.
 */
angular.module('aviApp').factory('DNSQueryCollection', [
'Collection', 'MetricData',
(Collection, MetricData) => {
    class DNSQueryCollection extends Collection {}

    angular.extend(DNSQueryCollection.prototype, {
        itemClass_: MetricData,
        objectName_: 'dnsquery',
        allDataSources_: {
            list: {
                source: 'DnsQueryMetricDataListCollDataSource',
                transformer: 'DNSQueryListDataTransformer',
                transport: 'ListDataTransport',
                fields: ['config'],
            },
        },
        isStatic_: false,
    });

    return DNSQueryCollection;
}]);
